module.exports = __webpack_public_path__ + "img/Kerrry_Express.cfabd1ae.svg";